import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getAllDrinks,
  getSingleDrink,
  createDrink,
  updateDrink,
  deleteDrink,
  websiteOrderingAvailableItemsToggle,
} from "@/api/new-api/staff-management/menu-manage/drink";
import { getAllGiftCardApi } from "@/api/giftCard";
import { deleteGiftCardHistoryApi, getAllGiftCardHistoryApi } from "@/api/giftCardHistory";

// Thunks

export const fetchAllGiftCardHistories = createAsyncThunk(
  "giftCardHistories/fetchAll",
  async (
    { restaurant_id, page = 1, search = "", status = "", per_page = 10 },
    { rejectWithValue }
  ) => {
    const params = new URLSearchParams();

    params.append("per_page", per_page);
    params.append("page", page);

    if (search) {
      params.append("search_term", search);
    }

    if (status) {
      params.append("status", status);
    }

    const res = await getAllGiftCardHistoryApi(restaurant_id, params.toString());

    if (res.status === "success") {
      return { ...res.data, search };
    }

    return rejectWithValue(res.message);
  }
);

export const deleteGiftCardHistoryById = createAsyncThunk(
  "giftCardHistories/delete",
  async (id, { rejectWithValue }) => {
    const res = await deleteGiftCardHistoryApi(id);
    if (res.status === "success") return id;
    return rejectWithValue(res.message);
  }
);

// Initial State

const initialState = {
  giftCardHistories: [],
  singleGiftCardHistoryCard: null,
  totalGiftCardHistoryPages: 1,

  getGiftCardHistoryLoading: false,
  createGiftCardHistoryLoading: false,
  updateGiftCardHistoryLoading: false,
  deleteGiftCardHistoryLoading: false,

  success: null,
  error: null,
  requestStatus: false,
  searchGiftCardHistory: "",
  giftCardHistoryStatus: "",
  giftCardHistoryPerPage: 10,
  giftCardHistoryCurrentPage: 1
};

// Slice

const giftCardHistorySlice = createSlice({
  name: "giftCardHistories",
  initialState,
  reducers: {
    clearGiftCardHistoryMessages: (state) => {
      state.success = null;
      state.error = null;
      state.requestStatus = false;
      state.totalGiftCardHistoryPages = 1;
        state.searchGiftCardHistory = "";
      },
      setGiftCardHistorySearch: (state, action) => {
        state.searchGiftCardHistory = action.payload;
      },
      setGiftCardHistoryStatus: (state, action) => {
        state.giftCardHistoryStatus = action.payload;
      },
      setGiftCardHistoryPerPage: (state, action) => {
        state.giftCardHistoryPerPage = action.payload;
      },
      setGiftCardHistoryCurrentPage: (state, action) => {
        state.giftCardHistoryCurrentPage = action.payload;
      },
  },
  extraReducers: (builder) => {
    builder

      // Fetch All
      .addCase(fetchAllGiftCardHistories.pending, (state) => {
        state.getGiftCardHistoryLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(fetchAllGiftCardHistories.fulfilled, (state, action) => {
        state.getGiftCardHistoryLoading = false;
        state.giftCardHistories = action.payload.gift_card_histories;
        state.requestStatus = true;
        state.totalGiftCardHistoryPages = action.payload.pagination.last_page;
      })
      .addCase(fetchAllGiftCardHistories.rejected, (state, action) => {
        state.getGiftCardHistoryLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      })

      // Delete
      .addCase(deleteGiftCardHistoryById.pending, (state) => {
        state.deleteLoading = true;
        state.error = null;
        state.requestStatus = false;
      })
      .addCase(deleteGiftCardHistoryById.fulfilled, (state, action) => {
        state.deleteLoading = false;
        state.giftCardHistories = state.giftCardHistories.filter(
          (item) => item.id !== action.payload
        );
        state.success = "Gift Card History Deleted Successfully!";
        state.requestStatus = true;
      })
      .addCase(deleteGiftCardHistoryById.rejected, (state, action) => {
        state.deleteLoading = false;
        state.error = action.payload;
        state.requestStatus = false;
      });
  },
});

export const { clearGiftCardHistoryMessages, setGiftCardHistorySearch, setGiftCardHistoryCurrentPage, setGiftCardHistoryPerPage, setGiftCardHistoryStatus } = giftCardHistorySlice.actions;
export default giftCardHistorySlice.reducer;
